import React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SiteAdmin from '../components/SiteAdmin';
import Page from '../../../components/Page';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import IconButton from '@material-ui/core/IconButton';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import ReportIcon from '@material-ui/icons/InsertChart';
import OverdueIcon from '@material-ui/icons/Alarm';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import { BillingAPI } from '../../../api';
import { Link } from 'react-router-dom';
import moment from 'moment';

import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import withAdminOnly from '../components/AdminOnly';

const useStyles = makeStyles({
  title: {
    marginBottom: '2rem',
  },
});

// this is how we override the US-centric date formatting at the top of the month calendar.
class LocalizedUtils extends MomentUtils {
  getDatePickerHeaderText(date) {
    return date.format('D MMMM', { locale: this.locale });
  }
}

const BillingAdminPage = () => {
  const [fromDate, setFromDate] = useState(moment().clone().startOf('month'));
  const [toDate, setToDate] = useState(moment().clone().endOf('month'));
  const [financeReportDownloadBusy, setFinanceReportDownloadBusy] = useState(false);
  const classes = useStyles();

  const financeReportDownload = async() => {
    try {
      setFinanceReportDownloadBusy(true);
      const { payload } = await BillingAPI.getFinanceReportUrl(fromDate.format('YYYY-MM-DD'), toDate.format('YYYY-MM-DD'));
      window.open(payload.url);
    } finally {
      setFinanceReportDownloadBusy(false);
    }
  };

  return (
    <Page title="Billing Reports">
      <SiteAdmin>
        <Typography variant="h6" color="primary" className={classes.title}>Billing Reports</Typography>
        <Container>
          <MuiPickersUtilsProvider utils={LocalizedUtils}>
            <List aria-label="report list">
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <ReportIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Finance Report"
                  secondary="XLS Spreadsheet for finance reconciliation"
                />
                <DatePicker autoOk={true} label="From" value={fromDate} onChange={setFromDate} maxDate={toDate} format="DD/MM/yyyy"/>
                <DatePicker autoOk={true} label="To" value={toDate} onChange={setToDate} minDate={fromDate} format="DD/MM/yyyy"/>
                <ListItemSecondaryAction>
                  <IconButton disabled={financeReportDownloadBusy} edge="end" aria-label="download" onClick={()=>financeReportDownload()}>
                    <DownloadIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>

              <ListItem button component={Link} to="/siteadmin/billing/overdue">
                <ListItemAvatar>
                  <Avatar>
                    <OverdueIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Overdue Subscriptions"
                  secondary="View overdue accounts and retry transactions."
                />
              </ListItem>

            </List>
          </MuiPickersUtilsProvider>
        </Container>
      </SiteAdmin>
    </Page>
  );
};

export default withAdminOnly(BillingAdminPage);
